var boostPFSInstantSearchConfig={search:{suggestionMobileStyle:"style2"}};(function(){BoostPFS.inject(this),SearchInput.prototype.customizeInstantSearch=function(suggestionElement,searchElement,searchBoxId){}})();
//# sourceMappingURL=/s/files/1/0620/9578/6192/t/26/assets/boost-pfs-instant-search.js.map?v=1688101779
